import React from "react";
import { Stack } from "@mui/material";
import { BarcodeStickers, PagePrint } from "../../components";
import { getBarcodeSize } from "../../constants/barcodes";

const defaultGap = 5 / 32;
const defaultMargin = {
  top: 0.5,
  left: defaultGap,
  bottom: 0.5,
  right: defaultGap,
};

// Helper function to chunk the array into subarrays of the specified size
const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

const getMargin = (margin) =>
  `${margin.top}in ${margin.right}in ${margin.bottom}in ${margin.left}in`;

export const BarcodePage = ({
  labels = [],
  size = 1,
  format = "CODE128",
  displayValue = true,
  columns = 1,
  columnGap = 0,
  rows = 1,
  rowGap = 0,
  margin = defaultMargin,
}) => {
  const chunkSize = columns * rows;
  const barcodes =
    chunkArray(labels, chunkSize)?.filter((chunk) => chunk?.length) || [];

  const grid = getBarcodeSize(size);
  const pageSx = {
    padding: getMargin(margin),
    columnGap: `${columnGap}in`,
    rowGap: `${rowGap}in`,
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, ${grid.width})`,
    gridTemplateRows: `repeat(${rows}, ${grid.height})`,
  };
  return (
    <Stack
      gap="25px"
      className="print-only"
      sx={{
        ".print-only": {
          boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.2)",
          "@page": { size: "8.5in 11in", margin: 0 },
        },
      }}
    >
      {barcodes.map((chunk, index) => (
        <PagePrint
          key={`page-${index}`}
          cardProps={{ id: `page-${index}`, sx: { position: "relative" } }}
          stackProps={{ sx: pageSx }}
          margin={0}
        >
          {chunk?.map(({ barcode, top, bottom }) => {
            const props = {
              barcode,
              top,
              bottom,
              size: size,
              barcodeProps: { format, displayValue },
            };
            return <BarcodeStickers {...props} />;
          })}
        </PagePrint>
      ))}
    </Stack>
  );
};

export default BarcodePage;
